import { Component, OnInit, ElementRef, ViewChild, forwardRef, Input, SimpleChanges, OnChanges, HostListener, HostBinding, Output, EventEmitter, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil, set } from 'lodash-es';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { LoadContainers_ShellService } from './LoadContainers.shell.service';
import { LoadContainers_OperationService } from './LoadContainers.operation.service';
import { LoadContainers_DatasourceService } from './LoadContainers.datasource.index';
import { LoadContainers_FlowService } from './LoadContainers.flow.index';
import { LoadContainers_ReportService } from './LoadContainers.report.index';
import { LoadContainers_LocalizationService } from './LoadContainers.localization.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './LoadContainers.frontend.types'
import { $frontendTypes as $types} from './LoadContainers.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'LoadContainers-order_date_types_multi',
  templateUrl: './LoadContainers.order_date_types_multi.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LoadContainers_order_date_types_multiComponent),
      multi: true
    }
  ]
})
export class LoadContainers_order_date_types_multiComponent extends BaseComponent implements OnInit, ControlValueAccessor {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;
  @Input() tooltip = '';

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;

  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return true;
  }

  get isSingle() {
    return false;
  }

  options: Array<{ key: any; name: string; disabled?: boolean; }> = [
    {
      key: 'FulfillmentDate',
      name: 'Fulfillment',
      disabled: null
    },  
    {
      key: 'RequestedDeliveryDate',
      name: 'Requested Delivery',
      disabled: null
    },  
    {
      key: 'CancelThresholdDate',
      name: 'Cancel Threshold',
      disabled: null
    },  
    {
      key: 'ReadyToExportDate',
      name: 'Ready To Export',
      disabled: null
    },  
    {
      key: 'CreatedSysDateTime',
      name: 'Created',
      disabled: null
    },  
    {
      key: 'ModifiedSysDateTime',
      name: 'Modified',
      disabled: null
    },  
  ];


  fullTextSearch: string;

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: LoadContainers_ShellService,
    private datasources: LoadContainers_DatasourceService,
    private flows: LoadContainers_FlowService,
    private reports: LoadContainers_ReportService,
    private localization: LoadContainers_LocalizationService,
    private operations: LoadContainers_OperationService,
    private logger: CleanupLoggerService,
    private _elementRef: ElementRef
    ) {
      super();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  async $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): string | string[] {
    return this._innerValue;
  }

  set value(val:  string | string[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  displayWithFn(value: any): Promise<{displayText:string, selected :Array<{ key: any; name: string; disabled?: boolean; selected?: boolean;}>}> {
    const selected = this.options.filter(o => value.includes(o.key));
    const displayText = selected.map(o => o.name).join(
           ', '
        );
    this.displayTextChange.emit(displayText);
    return Promise.resolve({displayText, selected});
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    if (filterText.length > 0) {
      const list = this.options.filter(item => item.name.startsWith(filterText))
      return Promise.resolve({ list, totalCount: this.options.length, top: null });
    } else {
      const list = [...this.options];
      return Promise.resolve({ list, totalCount: this.options.length, top: null });
    }
  }

}
